import React, {
    useEffect,
    useContext,
    useState,
} from "react"

import {
    useNavigate,
} from "react-router-dom"

import {
    Container,
} from "react-bootstrap"

import ViewAssessmentsVM, {
    EMETLAssessmentTableRow,
} from "../ViewModel/ViewAssessments.vm"

import {
    clearSelected,
} from "./CreateAssessment"

import EMETLAssessmentSearchHeader from "./Components/Header/EMETLAssessmentSearchHeader"
import EMETLTable from "./Components/EMETLTable"

import "./Stylesheets/Assessments.css"
import "./Stylesheets/ViewAssessments.css"

import {
    Context,
    EMETLContext,
} from "../Model/Contexts/AppContext"

export type ViewAssessmentsProps = {
    wantsQuarterlyData?: boolean,
    wantsTemplates?: boolean,
}

const ViewAssessments = (props?: ViewAssessmentsProps) => {
    const {
        wantsQuarterlyData,
        wantsTemplates,
    } = props

    const {
        amplify,
        assessmentData,
        loading: {
            update: setLoading,
            setMessage,
        },
        header: {
            update: setHeader,
        }
    } = useContext(Context) as EMETLContext

    const navigate = useNavigate()
    const assessments = assessmentData?.assessments?.value

    const _init = async () => {
        ViewAssessmentsVM.db = amplify
        if (wantsQuarterlyData && !assessments?.length) {
           
            const qd = await ViewAssessmentsVM.loadQuarterlyAssessmentData()
            assessmentData?.assessments?.update(qd)
      
        } else if (wantsTemplates && !assessments?.length) {
            const templates = await ViewAssessmentsVM.loadTemplates()
            assessmentData?.assessments?.update(templates.map(t => ({
                ...t,
                __typename: "Assessment",
                TrainingType: t?.TrainingType || ViewAssessmentsVM.getDefaultTrainingType(),
            })))
        }
    }

    const _refresh = async () => {
        await _init()
        // Set additional state variables here...
    }

    const assessmentToTableRow = (a): EMETLAssessmentTableRow => {
        const createdAt = new Date(`${a.Created}Z`)
        
        const t = createdAt.toLocaleTimeString([], { 
            hour12: false, 
            hour: "2-digit", 
            minute: "2-digit", 
        })

        return [
            {
                title: a.ID,
            },
            {
                title: a.Title,
                subtitle: a.TaskNumbers
            },
            {
                title: createdAt.toLocaleDateString(),
            },
            {
                title: t,
            }, 
            {
                title: ViewAssessmentsVM.TRAINING_TYPES[a.TrainingType],
            }, 
            {
                title: a.AssessorName,
            },
        ]
    }

    const handleSelectAssessment = async (assessmentRow: EMETLAssessmentTableRow) => {
        // Set the selected assessment in the view model
        // ViewAssessmentsVM.selectedAssessment = assessment
        const [{
            title: assessmentID,
        }] = assessmentRow

        setLoading(true)
        setMessage(`Loading details for assessment ${assessmentID}`)
        const assessment = await ViewAssessmentsVM.loadAssessment(assessmentID)
        if (!assessment || assessment && !assessment.ID) {
            setLoading(false)
            setMessage("")
            alert("Error loading assessment details.")
            return
        }
        setLoading(false)
        setMessage("")
        clearSelected()
        assessmentData?.assessmentTasks?.update([])
        navigate("/Assessment", {
            state: {
                assessment,
            }
        })
    }

    useEffect(() => {
        if (!wantsQuarterlyData)
            setHeader(<EMETLAssessmentSearchHeader />)
        
        _init()
    }, [amplify, wantsQuarterlyData, wantsTemplates])

    return (
        <Container
            id="viewassessments"
        >
            {assessments && !!assessments?.length ? (
                <EMETLTable
                    rows={
                        assessments.map(assessmentToTableRow)
                    }
                    headers = {ViewAssessmentsVM.tableHeaders}
                    onSelectCell={handleSelectAssessment}
                    hideColumns={[0]}
                />
            ) : (
                <div>
                    No assessments found.
                </div>
            )}
        </Container>
    )
}

export default ViewAssessments
